import React from 'react';

function TextContentInner(props) {
    // First item: about text; Second item: core services heading + text
    const about = (props.content && props.content[0]) ? props.content[0] : { content: '' };
    const coreServices = (props.content && props.content[1]) ? props.content[1] : null;
    return (
        <>
            <div className="text-content-inner">
                <div className="container">
                    <div className="row d-flex align-items-start">
                        <div className="col-lg-6">
                            <div className="paragraph light-1">
                                <p>{about.content}</p>
                            </div>
                        </div>
                        {coreServices && (
                            <div className="col-lg-6">
                                <div className="paragraph light-1">
                                    <p>{coreServices.content}</p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

export default TextContentInner;
